import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"

import qbStyles from './qb_table.module.scss'
import SortableTable from "../table"
import TopTableBar from "../Extras/top_bar"


const QbTable = () => {

    // temp fillers for testing //
    const tempFields = [
        {
            'displayName' : 'Season',
            'refName' : 'season',
            'fieldGroup' : 'Season',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Starts',
            'refName' : 'games_started',
            'fieldGroup' : 'Season',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Points',
            'refName' : 'spread_val',
            'fieldGroup' : 'Value v Avg Starter',
            'displayType' : 'QbAts',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Change (Week)',
            'refName' : 'spread_val_wow',
            'fieldGroup' : 'Value v Avg Starter',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Change (Year)',
            'refName' : 'spread_val_ytd',
            'fieldGroup' : 'Value v Avg Starter',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Comp',
            'refName' : 'pass_comp',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Atts',
            'refName' : 'pass_atts',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Comp%',
            'refName' : 'comp_pct',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsPctRem',
            'displayParams' : {
                'percision' : 1,
                'rem' : '0.9rem'
            },
        },
        {
            'displayName' : 'CPOE',
            'refName' : 'cpoe',
            'fieldGroup' : 'Passing',
            'displayType' : 'Cpoe',
            'displayParams' : {'rem' : '0.8rem'},
        },
        {
            'displayName' : 'Yards',
            'refName' : 'passing_yards',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'YPA',
            'refName' : 'yards_p_att',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'TDs',
            'refName' : 'td',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'INTs',
            'refName' : 'int',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Sacks',
            'refName' : 'sacks',
            'fieldGroup' : 'Passing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Carries',
            'refName' : 'rush_atts',
            'fieldGroup' : 'Rushing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Yards',
            'refName' : 'rush_yards',
            'fieldGroup' : 'Rushing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'YPC',
            'refName' : 'yards_per_carry',
            'fieldGroup' : 'Rushing',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'TDs',
            'refName' : 'rush_tds',
            'fieldGroup' : 'Rushing',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'TD%',
            'refName' : 'td_rate',
            'fieldGroup' : 'Rates',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'INT%',
            'refName' : 'int_rate',
            'fieldGroup' : 'Rates',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'TD%-INT%',
            'refName' : 'td_int_net_rate',
            'fieldGroup' : 'Rates',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Success',
            'refName' : 'succsess_rate',
            'fieldGroup' : 'Rates',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Passer Rtg',
            'refName' : 'passer_rating',
            'fieldGroup' : 'Ratings',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'ANY/A',
            'refName' : 'any_a',
            'fieldGroup' : 'Ratings',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : '538 Elo',
            'refName' : 'average_qb_elo',
            'fieldGroup' : 'Ratings',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'QBR',
            'refName' : 'qbr_total',
            'fieldGroup' : 'Ratings',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Total',
            'refName' : 'total_epa',
            'fieldGroup' : 'EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : '/ DB',
            'refName' : 'avg_epa',
            'fieldGroup' : 'EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'Rushing',
            'refName' : 'qb_rush_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'Sacks',
            'refName' : 'sack_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'Inc',
            'refName' : 'incomplete_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'INTs',
            'refName' : 'interception_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'Air Yards',
            'refName' : 'completion_air_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'YAC',
            'refName' : 'completion_yac_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'Penalties',
            'refName' : 'net_penalty_epa_delta',
            'fieldGroup' : 'EPA Components vs League Average',
            'displayType' : 'EpaComp',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'aDOT',
            'refName' : 'adot',
            'fieldGroup' : 'Depth',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'vs Sticks',
            'refName' : 'v_sticks',
            'fieldGroup' : 'Depth',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'W',
            'refName' : 'wins',
            'fieldGroup' : 'Winning',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'L',
            'refName' : 'losses',
            'fieldGroup' : 'Winning',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'T',
            'refName' : 'ties',
            'fieldGroup' : 'Winning',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'CB',
            'refName' : 'comebacks',
            'fieldGroup' : 'Winning',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'WPA / DB',
            'refName' : 'wpa',
            'fieldGroup' : 'Winning',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 3},
        },
        {
            'displayName' : 'Total WPA',
            'refName' : 'total_wpa',
            'fieldGroup' : 'Winning',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },

    ]

    const defaultSort = [{
        'field' : 'spread_val',
        'direction' : 'dsc'
    }]


    // data //
    const data = useStaticQuery(graphql`
        query {
            allQbRanksCsv {
                nodes {
                    qb
                    first_name
                    last_name
                    season
                    games_started
                    spread_val
                    spread_val_wow
                    spread_val_ytd
                    rank
                    win_pct
                    average_qb_elo
                    average_qb_elo_era_adj
                    headshot_url
                    team
                    gsis_id
                    espn_id
                    birth_date
                    height
                    weight
                    jersey_number
                    college
                    unique_id
                    position
                    qb_plays
                    pass_atts
                    pass_comp
                    inc
                    int
                    td
                    passing_yards
                    sacks
                    sack_yards
                    rush_atts
                    rush_yards
                    rush_tds
                    yards_p_att
                    td_rate
                    int_rate
                    comp_pct
                    td_int_net_rate
                    yards_per_carry
                    any_a
                    passer_rating
                    adot
                    v_sticks
                    cpoe
                    total_epa
                    avg_epa
                    succsess_rate
                    qb_rush_epa_delta
                    sack_epa_delta
                    incomplete_epa_delta
                    interception_epa_delta
                    completion_air_epa_delta
                    completion_yac_epa_delta
                    net_penalty_epa_delta
                    other_outcome_epa_delta
                    wpa
                    wins
                    losses
                    ties
                    comebacks
                    total_wpa
                    games_played
                    qbr_total
                    team_nick
                    team_logo_espn
                    team_color
                    team_color2
                }
            }
        }      
    `)
    
    // unique values for filtering //

    const seasons = []
    const players = []
    const teams = []

    data.allQbRanksCsv.nodes.forEach((row) => {

        if (!seasons.includes(row['season'])) {
            seasons.push(row['season'])
        }

        if (!players.includes(row['qb'])) {
            players.push(row['qb'])
        }

        if (!teams.includes(row['team_nick'])) {
            teams.push(row['team_nick'])
        }
    })



    // translate into dropdown options //
    const seasonOptions = seasons.map((row) => {
        return (
            {'value' : parseInt(row), 'label' : row}
        )
    })
    const playerOptions = players.map((row) => {
        return (
            {'value' : row, 'label' : row}
        )
    })
    const teamOptions = teams.map((row) => {
        return (
            {'value' : row, 'label' : row}
        )
    })

    // starting vals //
    const currentSeason = Math.max(...seasons)

    // drop states //
    // in logic, if array is blank, then we will take all //
    const [selectedSeasons, setSelectedSeasons] = useState([
        {'value' : currentSeason, 'label' : currentSeason}
    ])

    const [selectedPlayers, setSelectedPlayers] = useState([])
    const [selectedTeams, setSelectedTeams] = useState([])
    const [selectedMinAtts, setSelectedMinAtts] = useState('')
    
    const updateMinAtts = event => {
        setSelectedMinAtts(event.target.value)
    }
    // filter data //
    // first create arrays of selected values that can be checked //
    // as we iterate over the dataset //

    // seasons //
    const seasonVals = selectedSeasons.map((season) => {
        return(
            season['value']
        )
    })

    //players //
    const playerVals = selectedPlayers.map((player) => {
        return(
            player['value']
        )
    })

    // teams //
    const teamVals = selectedTeams.map((team) => {
        return(
            team['value']
        )
    })

    const filteredData = data.allQbRanksCsv.nodes.filter((row) => {

        // boolean to toggle if row is included //
        var includeBool = 1

        // seasons //
        if ((seasonVals.length === 0 && parseInt(row['season']) === currentSeason) || seasonVals.includes(parseInt(row['season']))) {
        
        } else {
            includeBool = includeBool * 0
        }

        // teams //
        if (teamVals.length === 0 || teamVals.includes(row['team_nick'])) {

        } else {
            includeBool = includeBool * 0
        }
      
        // players //
        if (playerVals.length === 0 || playerVals.includes(row['qb'])) {

        } else {
            includeBool = includeBool * 0
        }

        // Atts //
        if (isNaN(parseInt(selectedMinAtts))) {

        } else if (parseInt(row['pass_atts']) < parseInt(selectedMinAtts)) {
            includeBool = includeBool * 0
        }
              
        // if bool still 1 after filters, then add //
        if (includeBool === 1) {
            return (true)
        } else {
            return (false)
        }

    })

    // logic for handling scroll //
    const [tableScrolled, setTableScrolled] = useState(false)

    const handleScroll = e => {
        setTableScrolled(
            e.target.scrollLeft > 25
        )
    }

    // filters //
    const tableFilters = [
        {
            'filterId' : 'seasons',
            'filterName' : 'Seasons',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : seasonOptions,
                'onChange' : setSelectedSeasons,
                'values' : selectedSeasons,
                'default' : null
            }
        },
        {
            'filterId' : 'teams',
            'filterName' : 'Teams',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : teamOptions,
                'onChange' : setSelectedTeams,
                'values' : selectedTeams,
                'default' : null
            }
        },
        {
            'filterId' : 'qbs',
            'filterName' : 'QBs',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : playerOptions,
                'onChange' : setSelectedPlayers,
                'values' : selectedPlayers,
                'default' : null
            }
        },
        {
            'filterId' : 'minAtts',
            'filterName' : 'Min. Atts',
            'filterType' : 'numInput',
            'filterParams' : {
                'values' : selectedMinAtts,
                'onChange' : updateMinAtts
            }
        },
    ]

    return (

        <div className={qbStyles.team_container}>
            <TopTableBar
                tableData={filteredData}
                ignores={[]}
                fileName={'qbs.csv'}
                filters={tableFilters}
            />
            <div className={qbStyles.team_table_container} onScroll={handleScroll}>
                <SortableTable
                    records={filteredData}
                    fields={tempFields}
                    plateType={'player'}
                    defaultSort={defaultSort}
                    linkType={'none'}
                    idField={'unique_id'}
                    tableScrolled={tableScrolled}
                />    
            </div>
        </div>
    )
}

export default QbTable